import { computed } from 'vue';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

/**
 * Form-snapshot gate: the `form-snapshots` feature flag (docs/feature-flags.md).
 *
 * `isSnapshotsEnabled` activates the snapshot UI and flows (the Preview/Record toggle,
 * BnFormSnapshotView rendering, and the post-lock capture and upload) for any session that can
 * see the flag. FormSnapshotController checks the same flag server-side, from the same token
 * claim, so the two agree for the whole session.
 */
export const FORM_SNAPSHOTS_FLAG = 'form-snapshots';

export const useSnapshotGate = () => {
    const { isEnabled } = useFeatureFlags();
    const isSnapshotsEnabled = computed(() => isEnabled(FORM_SNAPSHOTS_FLAG));
    return { isSnapshotsEnabled };
};
